"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = refreshTokens;
const utils_1 = require("../utils");
const __1 = require("..");
const processEnv_1 = __importDefault(require("../utils/processEnv"));
async function refreshTokens(req, res, next) {
    const { refreshToken } = req.body;
    const accessToken = req.headers[__1.Constants.RequestHeaders.AccessToken];
    if (!refreshToken || !accessToken) {
        res.sendStatus(401);
    }
    else {
        try {
            const headers = {
                [__1.Constants.RequestHeaders.AccessToken]: accessToken,
                [__1.Constants.RequestHeaders.ApiKey]: processEnv_1.default.getValueOrThrow('SERVICES_API_KEY'),
            };
            const { data, status } = await (0, utils_1.sendAxiosPostRequest)((0, utils_1.getApiUrl)('/auth/api/v1/tokens/refresh'), { refreshToken }, headers);
            if (status === 200) {
                // Refresh the ongoing session on server side
                req.session.touch();
                req.session.accessToken = accessToken;
                // Return fresh tokens
                res.json(data);
            }
            else {
                res.sendStatus(403);
            }
        }
        catch (err) {
            console.error(`Refreshing tokens failed: ${err.message}`);
            if (err.isAxiosError) {
                res.status(err.response?.status || 403).json({
                    message: 'Unable to refresh tokens',
                });
            }
            else {
                res.status(500).json({ message: 'Server failed to refresh tokens' });
            }
        }
        next();
    }
}
